module.exports = __webpack_public_path__ + "static/media/sy.82a39d17.jpeg";